export enum InputFiedTypeEnum {
  USERNAME,
  EMAIL,
  PASSWORD,
  TEXTAREA
}
